import { store } from 'Store/store'

import { AppService } from 'AppServices/appService';

const { getPortalBusinessProfiles, getUserBusinessProfiles } = new AppService();

export class BusinessProfilesHelper {
  async getBusinessProfiles(isRoimatic = null){
    let user = store.state.auth.user;
    let portal = store.state.auth.portal;
    let businessProfilesFetchRequest = process.env.VUE_APP_CORDOVA_BUILD ? getUserBusinessProfiles(user.id, isRoimatic) : getPortalBusinessProfiles(user.id, portal.id, isRoimatic);
    return await businessProfilesFetchRequest;
  }
}